module.exports = __webpack_public_path__ + "img/news_6.ecec6203.png";